export default __webpack_public_path__ + "static/media/hero.90eb1a6a.png";